<template>
    <div :style="topStyle" :class="{ collapsed }">
        <slot></slot>
    </div>
</template>

<script>
    import Vue from 'vue';
    import debounce from 'lodash/debounce';
    import Responsive from '../../mixins/responsive';

    export default {
        mixins:[Responsive],
        data() {
            return {
                collapsed: false,
                collapsedHeight: 0,
                defaultHeight: 0,
                lastWinWidth: window.innerWidth,
                stickyEnabled: true
            }
        },
        computed: {
            topStyle() {
                return { paddingTop: this.collapsed ? `${this.defaultHeight}px` : '0' }
            },
            collapsingY() {
                let diff = this.defaultHeight-this.collapsedHeight;
                return diff<1 ? 1 : diff;
            }
        },
        methods: {
            getHeights() {
                let content = this.$slots.default[0].elm;
                let oldClass = this.$el.className;
                this.$el.classList.add('collapsed');
                this.collapsedHeight = content.offsetHeight;
                this.$el.classList.remove('collapsed');
                this.defaultHeight = content.offsetHeight;
                this.$el.className = oldClass;
            },
            update() {
                this.collapsed = this.stickyEnabled && pageYOffset > this.collapsingY;
            },
            handleResize: debounce(function () {
                if(window.innerWidth === this.lastWinWidth) {
                    return;
                }
                this.getHeights();
                this.update();
            }, 300),
            handleScroll(){
                this.update();
            }
        },
        mounted() {
            this.getHeights();
            window.addEventListener('scroll', this.handleScroll);
            window.addEventListener('resize', this.handleResize);
            this.$nextTick(this.update);

            this.$root.$on('header::disable-sticky', disabled => {
                if(window.innerWidth < this.breakpoints.md) {
                    this.stickyEnabled = !disabled;
                    if(!this.stickyEnabled) {
                        window.scrollTo(0,0);
                    }
                    this.update();
                }
            });

        },
        destroyed() {
            window.addEventListener('scroll', this.handleScroll);
            window.addEventListener('resize', this.handleResize)
        }
    }
</script>